// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import textColorStyles from '../../../styles/atoms/text-color.module.css'
import {
  IconProps,
  computeStrokeWidth,
  computeSize,
  IconComponentRef,
} from '../helpers'
const QuestionIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'question'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(
          className,
          styles.base,
          color && textColorStyles[color],
        )}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M8.71423 9.61794C8.93961 8.97723 9.38448 8.43697 9.97003 8.09284C10.5556 7.7487 11.244 7.6229 11.9134 7.73773C12.5829 7.85255 13.19 8.20058 13.6274 8.72018C14.0648 9.23978 14.3042 9.89741 14.3032 10.5766C14.3032 12.4939 11.4272 13.4526 11.4272 13.4526M11.5039 17.2872H11.5139M7.9 19.9978C9.80858 20.9769 12.0041 21.2421 14.0909 20.7456C16.1777 20.2492 18.0186 19.0237 19.2818 17.29C20.545 15.5564 21.1474 13.4286 20.9806 11.29C20.8137 9.15146 19.8886 7.14282 18.3718 5.62604C16.855 4.10927 14.8464 3.1841 12.7078 3.01727C10.5693 2.85043 8.44147 3.4529 6.70782 4.7161C4.97417 5.9793 3.74869 7.82016 3.25222 9.90696C2.75575 11.9938 3.02094 14.1893 4 16.0978L2 21.9978L7.9 19.9978Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)
QuestionIcon.displayName = 'QuestionIcon'
export { QuestionIcon }
